//components/rental-managers/RentalManagers.jsx



// src/components/rental-managers/RentalManagers.jsx
import React from 'react';
import { Box, Container } from '@mui/material';
import RentalManagersStyles from './RentalManagers.styles';
import RentalSEO from '../SEO/RentalSEO';
import WelcomeSection from './WelcomeSection';
import SmartLocksSection from './SmartLocksSection';
import AccessManagementSection from './AccessManagementSection'; // Fixed typo
import AccessManagementBenefits from './AccessManagementBenefits';
import AutomatedShowings from './AutomatedShowings';
import TenantGuidedTours from './TenantGuidedTours';
import GetStartedSection from './GetStartedSection';
import Header from '../header/Header';

const RentalManagers = () => {
  return (
    <>
      <RentalSEO />
      <Header />
      <Box sx={RentalManagersStyles.container}>
        <Container maxWidth="lg">
          {/* Welcome Section */}
          <WelcomeSection />

          {/* Smart Locks Section */}
          <SmartLocksSection />

          {/* Access Management Section */}
          <AccessManagementSection />

          {/* Access Management Benefits */}
          <AccessManagementBenefits />

          {/* Automated Showings */}
          <AutomatedShowings />

          {/* Tenant Guided Tours */}
          <TenantGuidedTours />

          {/* Get Started Section */}
          <GetStartedSection />
        </Container>
      </Box>
    </>
  );
};

export default RentalManagers;


// import React from 'react';
// import { Box, Container } from '@mui/material';
// import RentalManagersStyles from './RentalManagers.styles';
// import WelcomeSection from './WelcomeSection';
// import SmartLocksSection from './SmartLocksSection';
// import AccessManagementSection from './AccessMagementSection';
// import AccessManagementBenefits from './AccessManagementBenefits';
// import AutomatedShowings from './AutomatedShowings';
// import TenantGuidedTours from './TenantGuidedTours'; // New import
// import GetStartedSection from './GetStartedSection';
// import Header from '../header/Header';

// const RentalManagers = () => {
//   return (
//     <>
//       <Header />
//       <Box sx={RentalManagersStyles.container}>
//         <Container maxWidth="lg">
//           {/* Welcome Section */}
//           <WelcomeSection />

//           {/* Smart Locks Section */}
//           <SmartLocksSection />

//           {/* Access Management Section */}
//           <AccessManagementSection />

//           {/* Access Management Benefits */}
//           <AccessManagementBenefits />

//           {/* Automated Showings */}
//           <AutomatedShowings />

//           {/* Tenant Guided Tours */}
//           <TenantGuidedTours />

//           {/* Get Started Section */}
//           <GetStartedSection />
//         </Container>
//       </Box>
//     </>
//   );
// };

// export default RentalManagers;